
// file Route & run app adminPanel
import routing from './adminPanel.route';
import run from './adminPanel.run';

// controllers & services module Users
import userListController from './users/list/userListController';
import userCreateController from './users/create/userCreateController';
import userEditController from './users/edit/userEditController';
import modalDeleteUserController from './users/modal-delete/modalDeleteUserController';
import userServices from './users/userServices';

// controllers & services module Roles
import rolesListController from './roles/list/rolesListController';
import rolesCreateController from './roles/create/rolesCreateController';
import modalDeleteRolesController from './roles/modal-delete/modalDeleteRolesController';
import rolesServices from './roles/rolesServices';

// controllers & services module Levels
import levelsListController from './levels/list/levelsListController';
import levelsCreateController from './levels/create/levelsCreateController';
import levelsServices from './levels/levelsServices';

// controllers & services module Ambits
import ambitsListController from './ambits/list/ambitsListController';
import ambitsCreateController from './ambits/create/ambitsCreateController';
import ambitsServices from './ambits/ambitsServices';

// controllers & services module Cores
import coresListController from './cores/list/coresListController';
import coresCreateController from './cores/create/coresCreateController';
import coresServices from './cores/coresServices';

// controllers & services module Learning Objetives
import learningObjetivesListController from './learningObjetives/list/learningObjetivesListController';
import learningObjetivesCreateController from './learningObjetives/create/learningObjetivesCreateController';
import learningObjetivesServices from './learningObjetives/learningObjetivesServices';

// controllers & services module Indicators
import indicatorsListController from './indicators/list/indicatorsListController';
import indicatorsCreateController from './indicators/create/indicatorsCreateController';
import indicatorsServices from './indicators/indicatorsServices';

// controllers & services module Students
import studentsListController from './students/list/studentsListController';
import studentsCreateController from './students/create/studentsCreateController';
import studentsServices from './students/studentsServices';

// controllers & services module Educators
import educatorsListController from './educators/list/educatorsListController';
import educatorsCreateController from './educators/create/educatorsCreateController';
import educatorsServices from './educators/educatorsServices';

// controllers & services module enabled indicators
import enabledIndicatorsServices from './enabledIndicators/enabledIndicatorsServices'
import enabledIndicatorsListController from './enabledIndicators/list/enabledIndicatorsListController'

// controllers & services module enabled students
import enabledStudentsServices from './enabledStudents/enabledStudentsServices'
import enabledStudentsListController from './enabledStudents/list/enabledStudentsListController'

// controllers & services module enabled students
import enabledEducatorsServices from './enabledEducators/enabledEducatorsServices'
import enabledEducatorsListController from './enabledEducators/list/enabledEducatorsListController'


import modulesListController from './permissions/modules/modulesListController'
import permissionServices from './permissions/permissionServices';
import { listFilter } from '../../components/list-filter'


export default angular.module('app.adminPanel', [userServices,rolesServices,permissionServices,levelsServices,ambitsServices, coresServices, learningObjetivesServices, indicatorsServices, studentsServices, enabledIndicatorsServices, enabledStudentsServices, educatorsServices, enabledEducatorsServices])
  .config(routing)
  .controller('userListController', userListController)
  .controller('userCreateController', userCreateController)
  .controller('userEditController', userEditController)
  .controller('modalDeleteUserController', modalDeleteUserController)
  .controller('rolesListController', rolesListController)
  .controller('rolesCreateController', rolesCreateController)
  .controller('modalDeleteRolesController', modalDeleteRolesController)
  .controller('modulesListController', modulesListController)
  .controller('levelsListController', levelsListController)
  .controller('levelsCreateController', levelsCreateController)
  .controller('ambitsListController', ambitsListController)
  .controller('ambitsCreateController', ambitsCreateController)
  .controller('coresListController', coresListController)
  .controller('coresCreateController', coresCreateController)
  .controller('learningObjetivesListController', learningObjetivesListController)
  .controller('learningObjetivesCreateController', learningObjetivesCreateController)
  .controller('indicatorsListController', indicatorsListController)
  .controller('indicatorsCreateController', indicatorsCreateController)
  .controller('studentsListController', studentsListController)
  .controller('studentsCreateController', studentsCreateController)
  .controller('enabledIndicatorsListController', enabledIndicatorsListController)
  .controller('enabledStudentsListController', enabledStudentsListController)
  .controller('educatorsListController', educatorsListController)
  .controller('educatorsCreateController', educatorsCreateController)
  .controller('enabledEducatorsListController', enabledEducatorsListController)
  .component('listFilter',listFilter)
  .run(run)
  .constant("adminPanel", [{

    "title": "Admin-Panel",
    "icon":"mdi-account-settings-variant mdi-light",
    "subMenu":[  
      {  
        "title":"Usuarios",
        "url":"app.users"
      },
      {  
        "title":"Roles",
        "url":"app.roles"
      },
	  {  
        "title":"Niveles",
        "url":"app.levels"
      },
	  {  
        "title":"Ámbitos",
        "url":"app.ambits"
      },
	  {  
        "title":"Núcleos",
        "url":"app.cores"
      },
	  {  
        "title":"Objetivos Aprendizaje",
        "url":"app.learningObjetives"
      },
	  {
        "title":"Indicadores de Aprendizaje",
        "url":"app.indicators"
      },
	  {  
        "title":"Habilitación de Indicadores de Aprendizaje",
        "url":"app.enabledIndicators"
      },
	  {
        "title":"Docentes",
        "url":"app.educators"
      },
	  {  
        "title":"Habilitación de Docentes",
        "url":"app.enabledEducators"
      },
	  {
        "title":"Estudiantes",
        "url":"app.students"
      },
	  {  
        "title":"Habilitación de Estudiantes",
        "url":"app.enabledStudents"
      },
	]
}])
.name;


// WEBPACK FOOTER //
// ./src/app/admin-panel/index.js